import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropzone from "react-dropzone";
import {ButtonSimple} from "../../../../Elements/Buttons";

import {isEmpty} from "lodash";
import {capitalize} from "../../../../../utils";
import {BAND, LIVE_MUSIC, MUSICIAN, SERVICE} from "../../../../../consts";

// styles
import './styles.css';
import MdAdd from 'react-icons/lib/md/add';
import {clientMedia} from "../../../../../Config/Settings";

const RES_WEB = '800x300'; // not in use for now
const RES_MOBILE = '390x260';

class BannerCards extends Component {
    constructor() {
        super();

        // TODO: Web - TBD
        this.state = {
            urlLiveMusicMobile: `${clientMedia()}/img/bannerImages/banner-mobile-liveMusic.jpg`,
            urlServiceMobile: `${clientMedia()}/img/bannerImages/banner-mobile-service.jpg`,
            urlBandMobile: `${clientMedia()}/img/bannerImages/banner-mobile-band.jpg`,
            urlMusicianMobile: `${clientMedia()}/img/bannerImages/banner-mobile-musician.jpg`
        }
    }

    componentDidMount() {
        this.setState({


        })
    }

    getStoredImg(bannerType, platform) {
        if (platform === 'mobile') return this.getStoredImgMobile(bannerType);
        if (platform === 'web') return this.getStoredImgWeb(bannerType);
    }

    getStoredImgMobile(bannerType) {
        if (bannerType === LIVE_MUSIC) return this.state.urlLiveMusicMobile;
        if (bannerType === SERVICE) return this.state.urlServiceMobile;
        if (bannerType === BAND) return this.state.urlBandMobile;
        if (bannerType === MUSICIAN) return this.state.urlMusicianMobile;
        return '';
    }

    // TODO: TBD
    getStoredImgWeb(bannerType) {
        return ''
    }

    resetStoredImg(bannerType, platform) {
        if (platform === 'mobile') {
            if (bannerType === LIVE_MUSIC) return this.setState({ urlLiveMusicMobile: '' });
            if (bannerType === SERVICE) return this.setState({ urlServiceMobile: '' });
            if (bannerType === BAND) return this.setState({ urlBandMobile: '' });
            if (bannerType === MUSICIAN) return this.setState({ urlMusicianMobile: '' });
        }
    }

    setImageFile(file, type, err) {
        if (!file || !file[0] || (err && err.length > 0)) return alert(`Something went wrong with file upload, make sure its not to large`);

        if (err && err.length > 0) return console.log('failed uploading local file', err);
        file[0].cat = type
        this.setState({ [type]: file });
    }

    handleDeleteClick(e, bannerType, platform) {
        e.stopPropagation();
        if (this.state[bannerType]) return this.setState({ [bannerType]: null });
        if (this.getStoredImg(bannerType, platform)) return this.resetStoredImg(bannerType, platform);

        // TODO: delete datatypes stored image
        // this.props.deleteBanner(e, this.props.platform)
    }

    handleShowHideClick(e, bannerType, platform) {
        e.stopPropagation();

        this.props.handleShowHide(bannerType, !this.props.shownBanners[bannerType])
    }

    getFiles() {
        const files = [];
        Object.keys(this.state || []).forEach(cat => {
            if (cat && this.state[cat]) files.push(this.state[cat])
        })

        return files
    }

    renderImage(bannerType) {
        if (isEmpty(this.state[bannerType]) && !this.getStoredImg(bannerType, this.props.platform)) return null;

        let imageUrl = this.getStoredImg(bannerType, this.props.platform);

        if (this.state[bannerType] && this.state[bannerType][0]) {
            imageUrl = this.state[bannerType][0].preview;
        }

        if (!imageUrl) return null;

        return (
            <div
                className="upload-card img-tmp"
                style={{backgroundImage: 'url('+  imageUrl +')'}}
            >
            </div>
        )
    }

    renderBanner(bannerType, platform) {
        const isActive = this.props.shownBanners[bannerType];

        return (
            <div className="card">
                <div className="delete-banner" onClick={(e) => this.handleDeleteClick(e, bannerType, platform)}>X</div>
                <div
                    className={`activate-banner${isActive ? ' banner-visible' : ''}`}
                    onClick={(e) => this.handleShowHideClick(e, bannerType, platform)}
                >{isActive ? 'Active' : 'Hidden'}</div>

                {this.renderImage(bannerType)}
            </div>
        )
    }

    renderCard(bannerType, platform) {
        if (!bannerType) return null;

        return (
            <div className="card add-card" onClick={() => {}}>
                <div className="card-title">{bannerType === LIVE_MUSIC ? 'Live Music' : capitalize(bannerType)}</div>

                <div className="add-circle">
                    <Dropzone
                        onDrop={(file, err) => this.setImageFile(file, bannerType, err)}
                        minSize={1000}
                        maxSize={6500000} // TODO: tune better limitations than 6.5Mb
                        accept={"image/*"}
                        className="upload-card"
                    >
                        {this.getStoredImg(bannerType, platform) || this.state[bannerType] ? this.renderBanner(bannerType, platform) : <i><MdAdd /></i>}

                    </Dropzone>
                </div>
                <label className="res-label">{platform === 'web' ? RES_WEB : RES_MOBILE}</label>
            </div>
        )
    }

    render() {

        return (
            <div className="banner-cards-wrapper">
                <div className="content">
                    <div className="categories-cards-header">
                        {this.props.header}
                    </div>
                    <div className="cards">
                        <div className="cards">
                            {this.renderCard(LIVE_MUSIC, this.props.platform)}
                            {this.renderCard(SERVICE, this.props.platform)}
                            {this.renderCard(BAND, this.props.platform)}
                            {this.renderCard(MUSICIAN, this.props.platform)}
                        </div>
                    </div>
                </div>
                <ButtonSimple
                    onPress={() => this.props.handleSave(this.getFiles())}
                    label="Save Banners"
                />
            </div>
        )
    }
}

BannerCards.propTyeps = {
    header: PropTypes.string,
    platform: PropTypes.oneOf(['web', 'mobile']),
    openNew: PropTypes.func,
    openEdit: PropTypes.func,
    setImageFile: PropTypes.func,
    handleSave: PropTypes.func,
    handleShowHide: PropTypes.func,
    shownBanners: PropTypes.object
};

export default BannerCards;




// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/AdminComponents/BannerCards/BannerCards.js